var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbouticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.66 215.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007581;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.67,190.11C63.86,199.83,56.61,210,46,213.92c-14.09,5.17-29.63-1.58-38.21-13.23-8.77-11.91-9.3-28.06-5.73-42,5-19.58,17.76-36.89,34.33-48.47,11.74-8.2,24.93-13.06,38.82-16.14,22.18-4.94,52.85,6,69.48-14.51,8.59-10.58,8.32-26.52,1.82-38.5s-18.18-20.41-30.6-26A107.59,107.59,0,0,0,26,16.34L23.87,12C56.32-5.94,98.7-3.35,129.5,16.91c12.3,8.09,23.28,19.63,26.37,34,3.51,16.35-5,34.65-19.9,42.18-13.9,7-30.41,4.67-45.95,5.56a98.41,98.41,0,0,0-51.15,17.41C16,132.27-5.06,165.76,9.89,193.7c5.35,10,16.78,17.36,28.31,16.47,12.42-.95,20.5-12.33,25.55-22.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.24,9.6l.56,5.48C46.25,17,30.14,25.32,30,25.41l-2.55-4.89A112.89,112.89,0,0,1,64.24,9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.66,20.63l.63,5.47C47.54,28,32.92,35.92,32.77,36l-2.64-4.84A102.57,102.57,0,0,1,63.66,20.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.66,30.9l.81,5.45C49.49,38.28,38,45,37.89,45.1l-2.82-4.73A81.66,81.66,0,0,1,61.66,30.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.3,181.15a11.69,11.69,0,1,1,6.46,15.22,11.7,11.7,0,0,1-6.46-15.22Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbouticon);
export default __webpack_public_path__ + "static/media/abouticon.f71fb61f3ea51f692ba48207e2636635.svg";
export { ForwardRef as ReactComponent };